import React, { useEffect, useState } from "react";
import LoginCard from "../../components/LoginCard/LoginCard";


const Login = () => {
  return (
     <LoginCard />
  );
};

export default Login;
